<div [ngClass]="classUuID">
  <div class="input-content" [ngClass]="classUuID" role="button" tabindex="0" (click)="showCheckboxes()"
    (keydown.enter)="showCheckboxes()" (keydown.space)="showCheckboxes()">
    <input
      type="text"
      [ngClass]="classUuID"
      [(ngModel)]="valueDescription"
      (blur)="onTouched()"
    />
    <img
      src="../../../../assets/icons/arrow-select-icon.svg"
      alt="arrow"
      [ngClass]="classUuID"
    />
    <span class="floating-label" [ngClass]="classUuID">{{ placeholder }}</span>
  </div>
  <div class="options" [ngClass]="classUuID">
    <div
      id="checkboxes"
      [ngClass]="{ disabled: disabled, placeholder: classUuID }"
      [style.display]="expanded ? 'block' : 'none'"
      [style.maxHeight]="maxHeight + 'rem'"
    >
      <p
        *ngFor="let option of optionsList"
        role="button"
        tabindex="0"
        (click)="selectOptions(option)"
        (keydown.enter)="selectOptions(option)"
        (keydown.space)="selectOptions(option)"
        [ngClass]="classUuID"
      >
        <input
          *ngIf="multi"
          [ngClass]="classUuID"
          type="checkbox"
          [checked]="value.indexOf(option.id) !== -1"
        />
        {{ option.name }}
      </p>
    </div>
  </div>
</div>
